import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipstationField: {
    id: 'N/7Cvf',
    description: 'ShipStation Field',
    defaultMessage: 'ShipStation Field',
  },
});
